
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const Error500 = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    console.error("500 Error: Server error encountered");
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center">
          <div className="bg-red-100 p-3 rounded-full">
            <AlertTriangle className="h-12 w-12 text-red-500" />
          </div>
        </div>
        <h1 className="text-4xl font-serif font-bold text-gray-900">500</h1>
        <h2 className="text-2xl font-medium text-gray-800">Błąd serwera</h2>
        <p className="text-gray-600">
          Przepraszamy, wystąpił nieoczekiwany błąd po stronie serwera. Nasz zespół został
          powiadomiony o tym problemie i pracuje nad jego rozwiązaniem.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button 
            onClick={() => navigate("/")}
            variant="default"
          >
            Wróć do strony głównej
          </Button>
          <Button 
            onClick={() => window.location.reload()}
            variant="outline"
          >
            Odśwież stronę
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Error500;
